import { h } from 'preact';
import { Dropdown } from '../Dropdown';
import { Button } from '../Button';
import type { DropdownItem } from '../Dropdown';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Dropdown',
  category: '🗂️ Navegação',
  description: 'Menu dropdown com itens, divider e item danger',
  usedIn: ['AgentesPage', 'Integrations'],
  example: () => {
    const items: DropdownItem[] = [
      { label: 'Editar', onClick: () => {} },
      { label: 'Duplicar', onClick: () => {} },
      { type: 'divider' },
      { label: 'Excluir', onClick: () => {}, danger: true },
    ];
    return (
      <Dropdown
        trigger={<Button variant="secondary">Menu de opções</Button>}
        items={items}
      />
    );
  },
};
